import React from 'react';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

function AvatarCell(props) {
  const { cell } = props;
  return cell.value ? (
    <div className="fx actr ml8">
      <div>
        <Avatar
          initials={cell?.value?.firstName?.[0] || cell?.value?.name?.[0]}
          name={cell?.value?.firstName || cell?.value?.name}
          customer={false}
          size="extraSmall"
        />
      </div>
      <div className="ml8">
        <TextStyle>
          {cell?.value?.firstName || cell?.value?.name || (
            <FormattedMessage id="common.user.system" />
          )}
        </TextStyle>
      </div>
    </div>
  ) : (
    <TextStyle variation="subdued">
      <FormattedMessage id="app.noData.message" />
    </TextStyle>
  );
}

export default AvatarCell;
